<template>
  <v-carousel v-model="model" height="140" show-arrows-on-hover hide-delimiter-background>
    <v-carousel-item v-for="n in slides" :key="n">
      <v-sheet height="100%" color="background">
        <div class="d-flex flex-row flex-nowrap justify-center align-center full-height">
          <div class="d-flex flex-col" v-for="(module, ind) in slice(n)" :key="ind">
            <div style="min-width: 100px; border-radius: 5px" class="d-flex flex-column pa-3 mx-1 elevation-2 tile" @click="$router.push(buildRoute(module))">
              <n-title :fColor="darkMode ? 'white' : 'black'" class="text-center" style="white-space: nowrap">{{
                $te(module.title) ? $t(module.title) : module.title
              }}</n-title>
              <div class="mt-5" align="center" justify="center">
                <module-icon-with-badge
                  :unreadCountBadgeColor="theme.unreadBadgeColor"
                  :isUnreadCountFeatureEnabled="mx_isUnreadCountFeatureEnabled(module.type, module.instance)"
                  :iconColor="theme.moduleIconColor"
                  :module="module"
                  :unreadCount="mx_unreadCount(module)"
                ></module-icon-with-badge>
              </div>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import navigationMixin from '@/mixins/navigationMixin';
import NTitle from '@/components/texts/NTitle';
import ModuleIconWithBadge from '@/components/icons/ModuleIconWithBadge.vue';
export default {
  name: 'ModuleCarousel',
  mixins: [common, configMixin, navigationMixin],
  components: {
    NTitle,
    ModuleIconWithBadge,
  },

  props: {
    config: {
      type: Object,
    },
  },

  data() {
    return {
      model: 0,
    };
  },
  computed: {
    viewportWidthName() {
      return this.$vuetify.breakpoint.name;
    },
    currentModulesPerSlide() {
      return this.config.modulesPerSlide[this.viewportWidthName];
    },
    slides() {
      let slides = Math.ceil(this.modules.length / this.currentModulesPerSlide);
      return slides;
    },
  },
  methods: {
    slice(slideNumber) {
      let startInd = (slideNumber - 1) * this.currentModulesPerSlide;
      let endInd = startInd + this.currentModulesPerSlide;
      let slice = this.modules.slice(startInd, Math.min(this.modules.length, endInd));
      console.debug(`slice from ${startInd} - ${endInd}`);
      return slice;
    },
  },
};
</script>

<style scoped>
.box {
  border-radius: 5px;
  padding: 10px 4px;
  border: 1px solid #b0b0b0;
  height: 120px;
  min-width: 60px;
}
</style>
